// extracted by mini-css-extract-plugin
export default {"cta":"EI-z","disabled":"FI-z"};